import React from 'react'
import PropTypes from 'prop-types'
import { useHelpContext } from './hooks'
import { LinkPrimary } from 'mage-deps/@klarna/bubble-ui'
import { useEducationAnalytics } from 'education-tools'

HelpArticleLink.propTypes = {
  children: PropTypes.node.isRequired,
  slug: PropTypes.string.isRequired
}

function HelpArticleLink({ children, slug, ...props }) {
  const { navigation } = useHelpContext()

  const track = useEducationAnalytics({
    category: 'help-link/article',
    action: 'click',
    label: slug
  })

  function handleClick(e) {
    e.preventDefault()
    e.stopPropagation()
    track()
    navigation.push('article', { articleSlug: slug })
  }

  return (
    <LinkPrimary onClick={handleClick} {...props}>
      {children}
    </LinkPrimary>
  )
}

export default HelpArticleLink
